export const API_URL = process.env.REACT_APP_BASE_URL
export const AWS_BUCKET = process.env.REACT_APP_BASE_URL
export const AWS_ACCESS_KEY = process.env.REACT_APP_AWS_ACCESS_KEY
export const AWS_SECRET_KEY = process.env.REACT_APP_AWS_SECRET_KEY
export const AWS_REGION = process.env.REACT_APP_AWS_REGION
